module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"ds-manager:create-button":"Создать источник данных","ds-manager:navigation:item-name:ds-manager-general":"Менеджер источников данных","ds-manager:navigation:item-name:ds-manager-menu":"Меню создания источников данных"}}')
  delete Component.options._Ctor
}
